export function base64ToBlob(base64: string): Blob {
    const mimeMatch = base64.match(/^data:(.*);base64,/);
    const mime = mimeMatch ? mimeMatch[1] : 'application/pdf';
    const base64Data = base64.replace(/^data:.*;base64,/, '');
    const binary = atob(base64Data);
    const len = binary.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return new Blob([bytes], { type: mime });
}